import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { filter, first, isNil } from 'lodash'

import { Clinician } from '../../model/clinician'
import { CustomQuestionSchema } from '../../schema'
import { PatientIntakeFormData } from '../intake-form-data.class'
import { QuestionBase, QuestionOptions } from './base.question.class'

interface PhoneQuestionOptions extends QuestionOptions<string> {
  subscribeSms?: boolean
  subscribeSmsKey?: string
  subscribeSmsText?: string
}

export class PhoneQuestion extends QuestionBase<string> {
  controlType = 'phone'
  iconSuffix = 'phone'
  subscribeSms = false
  subscribeSmsKey?: string
  subscribeSmsText: string
  subscribeSmsValue = true

  controls: { [key: string]: UntypedFormControl | UntypedFormGroup }

  constructor(options: PhoneQuestionOptions = {}) {
    super(options)
    this.mask = {
      mask: [
        '+',
        /[1-9]/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ],
    }
    this.subscribeSms = options['subscribeSms']
    this.subscribeSmsKey = options['subscribeSmsKey']
    this.subscribeSmsText = options['subscribeSmsText']
  }

  toFormControls(fb: UntypedFormBuilder): { [key: string]: UntypedFormControl | UntypedFormGroup } {
    this.controls = {}

    if (this.isCustom) {
      this.control = fb.group({
        value: fb.control(this.value, this.getValidators()),
        note: fb.control(this.note),
      })
      this.controls[this.id] = this.control
    } else {
      this.control = fb.group({
        value: fb.control(this.value, this.getValidators()),
      })
      this.controls[this.key] = this.control
    }

    if (this.subscribeSms) {
      this.controls[this.subscribeSmsKey] = fb.control(this.subscribeSmsValue)
    }
    return this.controls
  }

  valueFromData(data: PatientIntakeFormData) {
    if (this.isCustom) {
      const value = first(filter(data.customQuestions, { id: this.id }))
      if (value) {
        this.value = value.value as any
        this.note = value.note
        this.clinicianId = value.clinicianId
      } else {
        this.value = undefined
      }
    } else {
      this.value = data[this.key]
      if (this.subscribeSms && !isNil(data[this.subscribeSmsKey])) {
        this.subscribeSmsValue = data[this.subscribeSmsKey]
      }
    }
  }

  saveValueToData(
    data: PatientIntakeFormData,
    form: UntypedFormGroup,
    clinician: Clinician,
  ) {
    if (this.isCustom) {
      const customData: CustomQuestionSchema = {
        id: this.id,
        value: form.value[this.id].value,
        note: form.value[this.id].note,
      }

      data.saveCustomQuestion(customData, clinician.id)
    } else {
      data[this.key] = form.value[this.key].value

      if (this.subscribeSmsKey) {
        data[this.subscribeSmsKey] = form.value[this.subscribeSmsKey]
      }
    }
  }
}
